<template>
  <v-container fluid class="max-width docForm">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Deposit Orders / Lipa Pole Pole ( Uncolleted )</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-btn color="primary" class="mt-2" small to="/new-lipa-pole-pole-record">
            <v-icon left dark>mdi-plus</v-icon>Create New Record
          </v-btn>
        </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table
              :headers="headers"
              :items="recordsData"
              :search="search"
              :mobile-breakpoint="0"
              :items-per-page="500"
            >
              <template v-slot:item.DocTotal="{ item }">
                <span>{{ item.DocTotal.toLocaleString() }}.00</span>
              </template>

              <template v-slot:item.CreatedAt="{ item }">
                <span>{{ item.CreatedAt | date }}</span>
              </template>

              <template v-slot:item.rows="{ item }">
                <div v-for="(value, index) in item.rows" v-bind:key="index">
                  <span v-show="index < 2">{{ value.product && value.product.Name }}</span>
                  <span v-show="index > 1"> ..... </span>
                  </div>
              </template>

              <template v-slot:item.action="{ item }">
                <v-btn text :to="`/lipa-pole-pole/${item.id}`" color="primary">
                  <v-icon left>mdi-eye</v-icon>Details
                </v-btn>
              </template>

              <template v-slot:item.delete="{ item }">
                <v-btn text @click="openDeleteDialog(item)" color="accent">
                  <v-icon left>mdi-delete</v-icon>Delete
                </v-btn>
              </template>
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="deleteDialog" persistent max-width="600">
      <v-card>
        <v-card-title class="headline">Confirm Delete</v-card-title>
        <v-card-text>
          <p><strong>Are you sure you want to delete this record? This action cannot be undone.</strong></p>
          <v-divider class="my-3"></v-divider>
          <div v-if="selectedRecord" class="text-body-1">
            <p class="mb-2"><strong>Doc No:</strong> <span class="font-weight-medium">{{ selectedRecord.DocNum }}</span></p>
            <p class="mb-2"><strong>Customer:</strong> <span class="font-weight-medium">{{ selectedRecord.customerName }}</span></p>
            <p class="mb-2"><strong>Phone:</strong> <span class="font-weight-medium">{{ selectedRecord.customerPhone }}</span></p>
            <p class="mb-2"><strong>Total:</strong> <span class="font-weight-medium">{{ selectedRecord.DocTotal.toLocaleString() }}.00</span></p>
            <p class="mb-2"><strong>Date:</strong> <span class="font-weight-medium">{{ selectedRecord.CreatedAt | date }}</span></p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="error" @click="deleteRecord" :loading="loader">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    date: new Date().toISOString().substr(0, 10),
    headers: [
      { text: "Doc No.", value: "DocNum" },
      { text: "Customer", value: "customerName" },
      { text: "Phone Number", value: "customerPhone" },
      { text: "Total", value: "DocTotal" },
      { text: "Item(s)", value: "rows" },
      { text: "Date", value: "CreatedAt" },
      { text: "View Details", value: "action" },
      { text: "Delete", value: "delete", sortable: false }
    ],
    recordsData: [],
    deleteDialog: false,
    selectedRecord: null,
    loader: false
  }),
  methods: {
    getRecords() {
      let data = {};
      data.StartDate = this.date;
      const self = this;
      const url = `/lipa-pole-pole`;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.recordsData = res.ResponseData;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    openDeleteDialog(item) {
      this.selectedRecord = item;
      this.deleteDialog = true;
    },
    deleteRecord() {
      const url = `/lipa-pole-pole/${this.selectedRecord.id}`;
      this.loader = true;
      this.$store
        .dispatch("remove", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            this.$refs.snackbar.show("Record deleted successfully", "green");
            this.getRecords(); // Refresh the list
            this.loader = false;
            this.deleteDialog = false;
            this.selectedRecord = null;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            this.loader = false;
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
          this.loader = false;
        });
    }
  },
  created() {
    this.getRecords();
  }
};
</script>